import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Container, Row, Col, Table, Form, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { triggerBase64Download } from "common-base64-downloader-react";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";
import {getDepList} from "../ManageDepartment/ManageDepSlice";
import { getAttendanceByName, getAttendanceExcel, updateSearchDetails } from "./AttendanceByNameSlice";
import { useNavigate } from "react-router-dom";

function AttendanceByNameComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchDetails, employeeLists } = useSelector((state) => state.AttendanceByNameSlice);
  const { fullname, department, start_date, end_date, start_time, end_time, time } = searchDetails;
  const [timeBetween, setTimeBetween] = useState(true);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [timeInputs, setTimeInputs] = useState({
    startHour: "08",
    startMinute: "30",
    startSecond: "00",
    endHour: "08",
    endMinute: "45",
    endSecond: "00",
  });

  const betweenAfter = [
    { value: "AFTER", label: "AFTER" },
    { value: "BETWEEN", label: "BETWEEN" }
  ];

  useEffect(() => {

    const initializeSearchDetails = () => {
      const startTime = `${timeInputs.startHour}:${timeInputs.startMinute}:${timeInputs.startSecond}`;
      const endTime = `${timeInputs.endHour}:${timeInputs.endMinute}:${timeInputs.endSecond}`;

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // Calculate the first day of the previous month
      // const startDate = new Date(currentYear, currentMonth, 1).toISOString().split("T")[0];
      const startDate = `${currentYear}-${currentMonth}-01`;
      const endDate = currentDate.toISOString().split("T")[0];

      const initialDetails = { ...searchDetails, 
        start_date: startDate,
        end_date: endDate, 
        start_time: startTime,
        end_time: endTime,
        time: "BETWEEN"
      };
      console.log(initialDetails)
      dispatch(updateSearchDetails(initialDetails));
    };

    initializeSearchDetails();

    dispatch(getDepList()).then((res) => {
      if (res.payload) {
        // Map departmentLists to { value, label } format for react-select
        const options = res.payload.map((dept) => ({
          value: dept.departments.id,
          label: dept.departments.description,
        }));
        // Add the 'ALL' option at the beginning or end of the options
        const allOption = { value: '', label: 'ALL DEPARTMENT' };  // You can set `value: null` if you prefer
        const allDepartmentOptions = [allOption, ...options]; // Optionally, you can reverse this for different placement

        setDepartmentOptions(allDepartmentOptions);
      }
    });
  }, []);

  const handleChangeForm = (e) => {
    const entity = { ...searchDetails, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateSearchDetails(entity));
  };

  const handleDepartmentChange = (selectedOption) => {

    if(selectedOption.label === "ALL DEPARTMENT"){
      const entity = { ...searchDetails, department: "" };
      console.log(entity);
      dispatch(updateSearchDetails(entity));
    }
    else{
      const entity = { ...searchDetails, department: selectedOption.label };
      console.log(entity);
      dispatch(updateSearchDetails(entity));
    }
  };

  const handleTimeChange = (selectedOption) => {
    if (selectedOption.value === "BETWEEN") {
      setTimeBetween(true);
    }
    else {
      setTimeBetween(false);
    }
    const entity = { ...searchDetails, time: selectedOption.value }; // Access label directly
    console.log(entity);
    dispatch(updateSearchDetails(entity));
  };

  const handleTimeInputChange = (e) => {
    const { name, value } = e.target;
    // setTimeInputs((prev) => ({ ...prev, [name]: value }));

    // Allow only numeric input and restrict length to 2 digits
    if (/^\d{0,2}$/.test(value)) {
      setTimeInputs((prevState) => ({
          ...prevState,
          [name]: value,
      }));
    }
  };

  const updateCombinedTime = (name) => {
    const combinedTime = `${timeInputs[`${name}Hour`]}:${timeInputs[`${name}Minute`]}:${timeInputs[`${name}Second`]}`;
    const entity = { ...searchDetails, [`${name}_time`]: combinedTime };
    console.log(entity)
    dispatch(updateSearchDetails(entity));
  };

  const handleClickSearch = () => {
    // Validate required fields
    if (!start_date || !end_date || !start_time || !end_time) {
      alert("Please fill out all fields." + "\n" + "(NOTE: Employee name and Department can be empty)");
      return; // Exit if validation fails
    }

    dispatch(getAttendanceByName(searchDetails));
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleExportExcel = () => {
    // Dispatch the action to fetch the Excel data
    // dispatch(getAttendanceExcel(employeeLists)).then((res) => {
    dispatch(getAttendanceExcel({employeeLists, department, start_date, end_date, start_time, end_time, time})).then((res) => {
      console.log(res);
      console.log(res.payload);
      
      // Create the base64 string for the Excel file
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload.file;
      
      // Trigger the download of the Excel file
      triggerBase64Download(
        base64EXCEL,
        "AttendanceLists_From_" + start_date + "_To_" + end_date
      );
    });
  };
  
  return (
    <div className="Div">
      <Container fluid>
        <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col
            xs={2}
            id="sidebar-wrapper"
            className="sidemenu"
            style={{ marginTop: "50px" }}
          >
            <SideMenu />
          </Col>
          <Col>
            {/* <Card className="content"> */}
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>ATTENDANCE REPORT</h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>EMPLOYEE NAME:</Col>
                    <Col md={9}>
                      <Form.Control 
                        name="fullname" 
                        placeholder="Search Employee" 
                        value={fullname} 
                        onChange={handleChangeForm} 
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>DEPARTMENT:</Col>
                    <Col md={9}>
                      <Select
                        onChange={handleDepartmentChange}
                        options={departmentOptions} // Use the mapped department options
                        value={departmentOptions.find((option) => option.value === department)}
                        placeholder="Select Department"
                      />
                    </Col>
                  </Row>
                  {/* <Row className="mb-3">
                    <Col md={3}>MANAGER:</Col>
                    <Col md={2}>
                    <Form.Check
                      // key={personnel.id}
                      type="checkbox"
                      // id={`personnel-${personnel.id}`}
                      label="YES"
                      // checked={selectedPersonnelIds.includes(personnel.id)}
                      // onChange={() => onPersonnelChange(personnel.id)}
                    />
                    </Col>
                  </Row> */}
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>FROM DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="start_date"
                        value={start_date}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                    <Col md={3}>
                      <Form.Label>TO DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="end_date"
                        value={end_date}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row className="mb-3 d-flex align-items-center">
                    <Col md={3}>
                      <Form.Label>TIME:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={handleTimeChange}
                        options={betweenAfter}
                        value={betweenAfter.find((option) => option.value === time)}
                        placeholder="Select Between or After"
                      />
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label></Form.Label>
                    </Col>
                    <Col md={3} className="d-flex align-items-center">
                      <Form.Control
                        type="text"
                        name="startHour"
                        placeholder="HH"
                        value={timeInputs.startHour}
                        onChange={handleTimeInputChange}
                        onBlur={() => updateCombinedTime("start")}
                        style={{ width: "4rem", textAlign: "center" }}
                      />&nbsp;&nbsp; : &nbsp;&nbsp;
                      <Form.Control
                        type="text"
                        name="startMinute"
                        placeholder="MM"
                        value={timeInputs.startMinute}
                        onChange={handleTimeInputChange}
                        onBlur={() => updateCombinedTime("start")}
                        style={{ width: "4rem", textAlign: "center" }}
                      />&nbsp;&nbsp; : &nbsp;&nbsp;
                      <Form.Control
                        type="text"
                        name="startSecond"
                        placeholder="SS"
                        value={timeInputs.startSecond}
                        onChange={handleTimeInputChange}
                        onBlur={() => updateCombinedTime("start")}
                        style={{ width: "4rem", textAlign: "center" }}
                      />
                    </Col>
                    {timeBetween && (
                      <>
                      <Col md={3}>
                        <Form.Label>AND</Form.Label>
                      </Col>
                      <Col md={3} className="d-flex align-items-center">
                        <Form.Control
                          type="text"
                          name="endHour"
                          placeholder="HH"
                          value={timeInputs.endHour}
                          onChange={handleTimeInputChange}
                          onBlur={() => updateCombinedTime("end")}
                          style={{ width: "4rem", textAlign: "center" }}
                        />&nbsp;&nbsp; : &nbsp;&nbsp;
                        <Form.Control
                          type="text"
                          name="endMinute"
                          placeholder="MM"
                          value={timeInputs.endMinute}
                          onChange={handleTimeInputChange}
                          onBlur={() => updateCombinedTime("end")}
                          style={{ width: "4rem", textAlign: "center" }}
                        />&nbsp;&nbsp; : &nbsp;&nbsp;
                        <Form.Control
                          type="text"
                          name="endSecond"
                          placeholder="SS"
                          value={timeInputs.endSecond}
                          onChange={handleTimeInputChange}
                          onBlur={() => updateCombinedTime("end")}
                          style={{ width: "4rem", textAlign: "center" }}
                        />
                      </Col>
                      </>
                    )}
                  </Row>
                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Card>
                    <Table bordered responsive>
                      <thead>
                        <tr className="tableheader">
                          <th className="text-center">Name</th>
                          <th className="text-center">Department</th>
                          <th className="text-center">Date</th>
                          <th className="text-center">Day</th>
                          <th className="text-center">Time In</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employeeLists && employeeLists.length > 0 ? (
                          employeeLists.map((employee, index) => (
                            <tr key={index}>
                              <td className="text-center">{employee.Name}</td>
                              <td className="text-center">{employee.Department}</td>
                              <td className="text-center">{employee.Date}</td>
                              <td className="text-center">{employee.Day}</td>
                              <td className="text-center">{employee.Time}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Card>
                  <Row className="mb-3 mt-3">
                    <Col md={1}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Col>
                    <Col md={9}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                      >
                        Download
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default AttendanceByNameComponent;